import { UseAuth } from "./AuthContext/AuthContext"
import { Usedata } from "./Context/Allcontext"
import {
    collection,
    getFirestore,
    addDoc,
    serverTimestamp
} from "firebase/firestore"
import { useState } from "react"
function Sako(){
    const { 
        Diyaariye,
        Nooc,
        setNooc,
        NDahab,
        setNDahab,
        Xadiga, 
        seXadiga,
        ActiveSako,
        setq_bixid,
        setq_isku_jir,
        q_isku_jir,
        q_bixid,
        setN_Midho,
        N_Midho,
    } =  Usedata()
    const {crentuser} = UseAuth()
    const emai_user = crentuser && crentuser.email
    //qeexida hore
    const db = getFirestore()
    //hellida collections

    const colref = collection(db, "transections")

    //gellin

    const Addingdhaqaaq = async(e) => {
        e.preventDefault()
        try{
            const data = await addDoc(colref, {
                email: emai_user,
                Nooca : Nooc,
                Xadiga : Xadiga,
                CreatedAt: Date.now()
            })
            console.log(q_isku_jir)
            console.log(q_bixid)
            Diyaariye()
        } catch(err){
            console.log(err)
        }
    }



    return(
        <form className="fooom active">
            <div className="close_oplsulet" onClick={ActiveSako}><i className="fa-solid fa-circle-xmark"></i></div>
                <div className="mid Sakawaat">
                    <span>
                        Dooro Nooca Sakada
                    </span>
                    <select name="nooc" value={Nooc} required onChange={(e) => setNooc(e.target.value)} autoFocus>
                        <option value="Lacag">
                            Lacag
                        </option>
                        <option value="Dahab">
                            Dahab
                        </option>
                        <option value="Fido">
                            Fido
                        </option>
                        <option value="Rikaas">
                            Rikaas
                        </option>
                        <option value="Geel">
                            Geel
                        </option>
                        <option value="Lo,a">
                            Lo,a
                        </option>
                        <option value="Adhi">
                            Adhi
                        </option>
                        <option value="Midho">
                            Midho
                        </option>

                    </select>
                </div>
                <div className="xadiga mid">
                    <input type="text" maxLength="17" minLength="1" spellCheck="false" autoComplete="off" name="xadiga" required placeholder="Tusaale 50,00" 
                    onChange={(e) => seXadiga(e.target.value)}
                    value={Xadiga}  />
                </div>
                {Nooc === "Dahab" ?
                <div className="mid Noocyad_dahabka active">
                    <span>
                        Dooro Nooca Dahabka
                    </span>
                    <select name="dahab" value={NDahab} required onChange={(e) => setNDahab(e.target.value)}>
                        <option value="24">
                            24
                        </option>
                        <option value="22">
                            22
                        </option>
                        <option value="21">
                            21
                        </option>
                        <option value="20">
                            20
                        </option>
                        <option value="18">
                            18
                        </option>
                    </select>

                </div>
                :Nooc === "Midho" ?
                <>
                <div className="checkh_box">
                    <h2>Dooro Sida Uu Ku Baxay  </h2>
                    <div className="doorasho">
                        <div className="gaar">
                        <input id="b_kharash" type="radio" value="b_kh" name="1" required 
                        onChange={(e) => setq_bixid(e.target.value)}
                        />
                        <label htmlFor="b_kharash">Bilaa Kharash</label>
                        </div>
                        <div className="gaar">
                        <input id="Kharash" type="radio" value="kha"  required name="1" 
                        onChange={(e) => setq_bixid(e.target.value)}
                        />
                        <label htmlFor="Kharash">Kharash</label>
                        </div>
                        <div className="gaar">
                        <input id="Isku_jir" type="radio" value="isk" name="1"  required 
                        onChange={(e) => setq_bixid(e.target.value)}
                        />
                        <label htmlFor="Isku_jir">Isku Jir</label>
                        </div>
                    </div>
                </div>
                {q_bixid === "isk" ? 
                    <div className="mid Noocyad_dahabka active">
                        <span>
                            Dooro Qaabka Isku Jirka
                        </span>
                        <select name="dahab" value={q_isku_jir} required onChange={(e) => setq_isku_jir(e.target.value)}>
                            <option value="50%">
                            Si Isleeg
                            </option>
                            <option value="sh_70%">
                            Kharashka Badan
                            </option>
                            <option value="shla_30%">
                            Kharash La,aanta Yar
                            </option>
                        </select>
                    </div>
                : <></>
                }

                <div className="mid Noocyad_dahabka active">
                    <span>
                        Dooro Nooca Midhaha
                    </span>
                    <select name="dahab" value={N_Midho} required onChange={(e) => setN_Midho(e.target.value)}>
                        <option value="Hadhuudh">
                        Hadhuudh
                        </option>
                        <option value="Galay">
                        Galay
                        </option>
                        <option value="Digir">
                        Digir
                        </option>
                        <option value="Heed">
                        Heed
                        </option>
                        <option value="Sareen">
                        Sareen
                        </option>
                        <option value="Qamadi">
                        Qamadi
                        </option>
                        <option value="Wax Kale">
                        Wax Kale
                        </option>
                    </select>
                </div>
                </>
            :<></>
            }
                <button type="submit" onClick={Addingdhaqaaq}> <i className="fa-solid fa-calculator"></i> Xisaabi</button>
        </form>
    )
}


export default Sako